import React from 'react';
import ReactDOM from 'react-dom';
import { AppContextProvider } from '../../../../Services/AppContext';
import { loadDOMComponent } from '../../../../helpers';
import AclContextProvider from '../../../../Modules/Acl/Components/AclContextProvider';
import { Provider } from 'react-redux';
import { store } from '../../../../store/store';
import QuestionnaireForDoctor from './QuestionnaireForDoctor';

loadDOMComponent({
	selector: 'react-questionnaire-for-doctor',
	callback: ({ container }: any) => {
		const wizardKey = container.getAttribute('key');

		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider>
					<AclContextProvider>
						<QuestionnaireForDoctor wizardKey={wizardKey} />
					</AclContextProvider>
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
